import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/pages/Login.vue'
import ResetPasswordRequest from '@/pages/ResetPasswordRequest.vue'
import ResetPassword from '@/pages/ResetPassword.vue'
import DashboardView from '@/pages/Dashboard.vue'
import DashboardGraph from '@/pages/DashboardGraph.vue'
import CompanyView from '@/pages/Company.vue'
import BranchView from '@/pages/Branch.vue'
import StaffView from '@/pages/Staff.vue'
import StaffDetailView from '@/pages/StaffDetail.vue'
import TodoView from '@/pages/Todo.vue'
import TodoMasterView from '@/pages/TodoMaster.vue'
import TodoMasterDetailView from '@/pages/TodoMasterDetail.vue'
import ElectronicApplicationView from '@/pages/ElectronicApplication.vue'
import SubsidyView from '@/pages/Subsidy.vue'
import Article36AgreementView from '@/pages/Article36Agreement.vue'
import eGovListView from '@/pages/eGovList.vue'
import eGovApplicationView from '@/pages/eGovApplication.vue'
import TermsView from '@/pages/Terms.vue'
import UserView from '@/pages/User.vue'
import OnetimeView from '@/pages/Onetime.vue'
import ContractView from '@/pages/Contract.vue'
import SubscriptionView from '@/pages/Subscription.vue'
import CancellationView from '@/pages/Cancellation.vue'
import InfoView from '@/pages/Info.vue'
import SystemInfoView from '@/pages/SystemInfo.vue'
import JoinView from '@/pages/Join.vue'
// import MailConfirmView from '@/pages/MailConfirm.vue'
import JoinMailSentView from '@/pages/JoinMailSent.vue'
import JoinCompleteView from '@/pages/JoinComplete.vue'
import Storage from '@/pages/Storage.vue'
import EmailChangeResult from '@/pages/EmailChangeResult.vue'
import EmailVerificationExpired from '@/pages/EmailVerificationExpired.vue'

// ページを追加するときはここに追加してください
const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    // メール認証リンク期限切れエラー
    {
      path: '/email-verification-expired',
      name: 'EmailVerificationExpired',
      component: EmailVerificationExpired,
      meta: {
        title: 'メール認証リンク期限切れ',
      },
    },
    // メールアドレス変更結果表示
    {
      path: '/email-change-result',
      name: 'EmailChangeResult',
      component: EmailChangeResult,
      meta: {
        title: 'メールアドレス変更結果',
      },
    },
    // 申し込み
    {
      path: '/join',
      name: 'Join',
      component: JoinView,
      meta: {
        title: 'ディーモ申込',
      },
    },
    // メール送信完了
    {
      path: '/joinmailsent',
      name: 'JoinMailSent',
      component: JoinMailSentView,
      meta: {
        title: 'メール送信完了',
      },
    },
    // 登録完了
    {
      path: '/joincomplete',
      name: 'JoinComplete',
      component: JoinCompleteView,
      meta: {
        title: '登録完了',
      },
    },
    // ログイン
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'ログイン',
      },
    },
    // パスワードを忘れた方はこちら
    {
      path: '/reset-password-request',
      name: 'ResetPasswordRequest',
      component: ResetPasswordRequest,
      meta: {
        title: 'パスワードを忘れた方はこちら',
      },
    },
    // パスワード再設定
    {
      path: '/reset-password/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        title: 'パスワード再設定',
      },
    },
    // ダッシュボード
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardView,
      meta: {
        title: 'ダッシュボード',
      },
    },
    // 業務負荷グラフ
    {
      path: '/dashboard-graph',
      name: 'dashboard-graph',
      component: DashboardGraph,
      meta: {
        title: '業務負荷グラフ',
      },
    },
    // 会社一覧
    {
      path: '/company',
      meta: {},
      children: [
        {
          path: '',
          name: 'company',
          component: CompanyView,
        },
        // 事業場一覧
        {
          path: '/company/:companyId/branch',
          name: 'branch',
          component: BranchView,
        },
        // 従業員一覧
        {
          path: '/company/:companyId/staff',
          name: 'staff',
          component: StaffView,
        },
        // 従業員詳細
        {
          path: '/company/:companyId/staff/:staffId',
          name: 'staffdetail',
          component: StaffDetailView,
        },
      ],
    },
    // 案件進捗
    {
      path: '/todo',
      meta: {},
      children: [
        {
          path: '',
          name: 'todo',
          component: TodoView,
        },
        // 案件マスタ一覧
        {
          path: '/todo/todomaster',
          name: 'todomaster',
          component: TodoMasterView,
        },
        // 案件マスタ詳細（編集）
        {
          path: '/todo/todomaster/:todoMasterId',
          name: 'todomasterdetail',
          component: TodoMasterDetailView,
        },
      ],
    },
    // 電子申請
    {
      path: '/electronicapplication',
      name: 'electronicapplication',
      component: ElectronicApplicationView,
    },
    // 助成金
    {
      path: '/subsidy',
      name: 'subsidy',
      component: SubsidyView,
    },
    // 36協定
    {
      path: '/article36agreement',
      name: 'article36agreement',
      component: Article36AgreementView,
      // component: Article36AgreementCopyView,
    },
    {
      // e-Gov電子申請
      path: '/egovapplication',
      name: 'egovapplication',
      component: eGovApplicationView,
      meta: {
        title: 'e-Gov電子申請',
      },
    },
    // e-Gov電子申請一覧
    {
      path: '/egovlist',
      name: 'egovlist',
      component: eGovListView,
    },
    // 利用規約
    {
      path: '/terms',
      name: 'terms',
      component: TermsView,
    },
    // ユーザー
    {
      path: '/user',
      name: 'user',
      component: UserView,
    },
    // ワンタイムパスワード
    {
      path: '/onetime',
      name: 'onetime',
      component: OnetimeView,
    },
    // 契約会社
    {
      path: '/contract',
      name: 'contract',
      component: ContractView,
    },
    // プラン契約
    {
      path: '/subscription',
      name: 'subscription',
      component: SubscriptionView,
      meta: {
        title: 'プラン契約',
      },
    },
    // 解約手続き
    {
      path: '/cancellation',
      name: 'cancellation',
      component: CancellationView,
      meta: {
        title: '解約手続き',
      },
    },
    // お知らせ
    {
      path: '/info',
      name: 'info',
      component: InfoView,
    },
    // システムお知らせ
    {
      path: '/systeminfo',
      name: 'systeminfo',
      component: SystemInfoView,
    },
    // ストレージ
    {
      path: '/storage/:uuid',
      name: 'storage',
      component: Storage,
    },
    // 404エラー時はログイン画面へリダイレクト
    {
      path: '/:pathMatch(.*)*',
      redirect: '/login',
    },
  ],
})

export default router
